import React, {useContext} from 'react';
import { faCog, faUser, faSignOutAlt, faCreditCard, faLaptopCode, faComment, faTools } from '@fortawesome/free-solid-svg-icons';
import SettingsTab from '../SettingsTab/SettingsTab.tsx';
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";
import {GlobalContext} from "../../../../App.tsx";
import {getFormattedEnvName} from "../../../../Utils/misc/envNameUtils.ts";
import {handleLogout} from "../../../../Utils/misc/miscUtils.ts";

interface SettingsMenuProps {
    onTabClick: (tabName: string) => void;
    activeTab: string;
}

const SettingsMenu: React.FC<SettingsMenuProps> = ({ onTabClick, activeTab }) => {
    const { resetStateHelper } = useContext(GlobalContext);

    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const setSettingsObj = useAppStore((state: any) => state.setSettingsObj);
    const setUserObj = useAppStore((state: any) => state.setUserObj);

    let formattedEnvName = getFormattedEnvName(environment);

    let tabs = [
        { name: 'General', icon: faCog },
        { name: 'Customization', icon: faUser },
        { name: 'Tools', icon: faTools },
        { name: 'Manage Account', icon: faCreditCard }
    ];


    if (formattedEnvName === "IDE") {
        // Find the index of the Tools tab and insert IDE right after it
        const toolsIndex = tabs.findIndex(tab => tab.name === 'Tools');
        const insertIndex = toolsIndex !== -1 ? toolsIndex + 1 : tabs.length;
        tabs.splice(insertIndex, 0, { name: 'IDE', icon: faLaptopCode });
    }

    tabs.push({ name: 'Feedback', icon: faComment });

    const handleSignOutClick = () => {
        setDynamicStateObj({visiblePopup: null});
        handleLogout(setSettingsObj, environment, vscode, setUserObj, setDynamicStateObj, resetStateHelper);
    };

    return (
        <div className="flex flex-col items-start p-4 w-full h-full sm:justify-between">
            <div className="w-full">
                <h2 className="text-xl font-bold dark:text-neutral-100 mb-4">Settings</h2>
                <div className="w-full space-y-2">
                    {tabs.map((tab) => (
                        <SettingsTab
                            key={tab.name}
                            name={tab.name}
                            icon={tab.icon}
                            isActive={activeTab === tab.name}
                            onClick={() => onTabClick(tab.name)}
                        />
                    ))}
                </div>
            </div>
            <div className="w-full mt-auto pt-4">
                <SettingsTab
                    name="Sign Out"
                    icon={faSignOutAlt}
                    isActive={activeTab === 'Sign Out'}
                    onClick={handleSignOutClick}
                />
            </div>
        </div>
    );
};

export default SettingsMenu;
